import Vue from "vue";
import Router from "vue-router";
import config from "./config.json";
const axios = require("axios");

Vue.use(Router);

const { collection } = config;

const SEARCH = "https://transkribus.eu/r/search-readV3";
const CONTENT_TYPE = "application/json; charset=utf-8";

const actions = {
  async fetchDocuments({ offset = 0, limit = 1000 } = {}) {
    try {
      const res = await axios.post(`${SEARCH}/documents`, {
        collections: [collection],
        offset,
        limit,
      });

      let docArray = res.data.grouped.docId.groups;
      docArray.map((doc) => {
        doc.documentId = doc.groupValue;
        delete doc.groupValue;
        delete doc.doclist;
      });
      return docArray;
    } catch (err) {
      console.log(err);
    }
    
  },
  async fetchDocumentsPages({ offset = 0, limit = 1000 } = {}) {
    let entireArray = []
    try {
      const resDoc = await axios.post(`${SEARCH}/documents`, {
        collections: [collection],
        offset,
        limit,
      });
      console.log(resDoc)
      let docArray = resDoc.data.grouped.docId.groups;
      docArray.map((doc) => {
        doc.documentId = doc.groupValue;
        delete doc.groupValue;
        delete doc.doclist;
      });
      for(let index in docArray){
        let id = docArray[index].documentId
        console.log(id)
        try {
          const resPage = await axios.post(`${SEARCH}/documents/${id}/pages/`, {
            offset,
            limit,
          });
          let pageArray = resPage.data.items
          pageArray.forEach(element => {
            entireArray.push({documentId :  element.id, pageNum : element.number})
          });         
          
          
        } catch (err) {
          console.error(err);
        }
      }
      
      return entireArray
      
    } catch (err) {
      console.log(err);
    }
  },
};
export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./pages/Home.vue'),
    // meta: {
    //   title: "Startseite"
    // }
  },
  {
    path: '/staticDirectory',
    name: 'StaticDirectory',
    component: () => import('./pages/StaticDirectory.vue'),
    // meta: {
    //   title: "Statisches Verzeichnis"
    // }
  },
  {
    path: '/tagDirectory',
    name: 'TagDirectory',
    component: () => import('./pages/TagDirectory.vue'),
    // meta: {
    //   title: "Statisches Tag-Verzeichnis"
    // }
  },
  {
    path: '/directory',
    name: 'Directory',
    component: () => import('./pages/Directory.vue'),
    // meta: {
    //   title: "Verzeichnis"
    // }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('./pages/Search.vue'),
    meta: {
      // title: "Suche",
      layout: 'default'
    }
  },
  {
    path: '/tags',
    name: 'Tags',
    component: () => import('./pages/Tags.vue'),
    meta: {
      // title: "Tags",
      layout: 'default'
    }
  },
  {
    path: '/meta',
    name: 'Metadata',
    component: () => import('./pages/Metadata.vue'),
    meta: {
      // title: "Metadata",
      layout: 'default'
    }
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('./pages/info.vue'),

  },
  {
    path: '/material',
    name: 'material',
    component: () => import('./pages/material.vue'),

  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('./pages/help/faq.vue'),
    meta: {
      // title: "Über",
      layout: 'narrow'
    }
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => import('./pages/help/usage.vue'),

  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('./pages/contact.vue'),
    meta: {
      layout: 'narrow'
    }

  },
  {
    path: "/documents/:documentId",
    name: "Document",
    component: () => import("./pages/Document.vue"),
    meta: {
      layout: "narrow",
      sitemap: {
        slugs: async () => await actions.fetchDocuments(),
      },
    },
  },
  {
    path: "/documents/:documentId/pages/:pageNum",
    name: "Browser",
    component: () => import("./pages/Browser.vue"),
    meta: {
      layout: "browser",
      sitemap: {
        slugs: async () => await actions.fetchDocumentsPages()
      },
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ './pages/About.vue'),
    meta: {
      // title: "Über",
      layout: 'narrow'
    }
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: () => import(/* webpackChunkName: "imprint" */ './pages/Imprint.vue'),
    meta: {
      // title: "Impressum"
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "Privacy" */ './pages/Privacy.vue'),
    meta: {
      // title: "Datenschutz",
      layout: 'narrow'
    }
  },
  {
    path: '/accessibility',
    name: 'Accessibility',
    component: () => import(/* webpackChunkName: "Privacy" */ './pages/Accessibility.vue'),
    meta: {
      // title: "Datenschutz",
      layout: 'narrow'
    }
  }
];



export default new Router({
  mode: 'history',
  base: config.publicPath,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./pages/Home.vue'),
      // meta: {
      //   title: "Startseite"
      // }
    },
    {
      path: '/browse',
      name: 'StaticDirectory',
      component: () => import('./pages/StaticDirectory.vue'),
      // meta: {
      //   title: "Statisches Verzeichnis"
      // }
    },
    {
      path: '/tagDirectory',
      name: 'TagDirectory',
      component: () => import('./pages/TagDirectory.vue'),
      // meta: {
      //   title: "Statisches Tag-Verzeichnis"
      // }
    },
    {
      path: '/directory',
      name: 'Directory',
      component: () => import('./pages/Directory.vue'),
      // meta: {
      //   title: "Verzeichnis"
      // }
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('./pages/Search.vue'),
      meta: {
        // title: "Suche",
        layout: 'default'
      }
    },
    {
      path: '/tags',
      name: 'Tags',
      component: () => import('./pages/Tags.vue'),
      meta: {
        // title: "Tags",
        layout: 'default'
      }
    },
    {
      path: '/meta',
      name: 'Metadata',
      component: () => import('./pages/Metadata.vue'),
      meta: {
        // title: "Metadata",
        layout: 'default'
      }
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('./pages/info.vue'),

    },
    {
      path: '/material',
      name: 'material',
      component: () => import('./pages/material.vue'),

    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./pages/help/faq.vue'),
      meta: {
        // title: "Über",
        layout: 'narrow'
      }
    },
    {
      path: '/usage',
      name: 'usage',
      component: () => import('./pages/help/usage.vue'),

    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./pages/contact.vue'),
      meta: {
        layout: 'narrow'
      }

    },
    {
      path: '/documents/:documentId',
      name: 'Document',
      component: () => import('./pages/Document.vue'),
      meta: {
        layout: 'narrow'
      }
    },
    {
      path: '/documents/:documentId/pages/:pageNum',
      name: 'Browser',
      component: () => import('./pages/Browser.vue'),
      meta: {
        layout: 'browser'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ './pages/About.vue'),
      meta: {
        // title: "Über",
        layout: 'narrow'
      }
    },
    {
      path: '/imprint',
      name: 'Imprint',
      component: () => import(/* webpackChunkName: "imprint" */ './pages/Imprint.vue'),
      meta: {
        // title: "Impressum"
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import(/* webpackChunkName: "Privacy" */ './pages/Privacy.vue'),
      meta: {
        // title: "Datenschutz",
        layout: 'narrow'
      }
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      component: () => import(/* webpackChunkName: "Privacy" */ './pages/Accessibility.vue'),
      meta: {
        // title: "Datenschutz",
        layout: 'narrow'
      }
    }
  ]
})
